import { Effect, Layer } from 'effect';
import { GavelConfig } from '../gavelConfig';
import { HttpService } from '../http';
import { TokenProviderService } from '../tokenProvider';
import { PutModularTemplate } from './gavel/requests';
import { PutModularTemplateResolver } from './gavel/resolvers';
import { ModularTemplateAuthoringService } from './service';
export const GavelModularTemplateAuthoringService = Layer.effect(ModularTemplateAuthoringService, Effect.gen(function* (_) {
    const http = yield* _(HttpService);
    const tokenProvider = yield* _(TokenProviderService);
    const gavelConfig = yield* _(GavelConfig);
    const gavelUrl = gavelConfig.gavelUrl;
    const putModularTemplateResolver = PutModularTemplateResolver(http, tokenProvider, gavelUrl);
    const putModularTemplate = (tenant, template) => Effect.request(PutModularTemplate({ tenant, template }), putModularTemplateResolver);
    return { putModularTemplate };
}));
